import * as React from 'react';
import BalanceSheetCore from '../AfrCore/BalanceSheetCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { Afr, generateLocalStateFromEventProperties, getSelectedAfr } from '../../redux/AfrSlice';




const BalanceSheetCoreWrapper = (props: { userRole: string }) => {
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const fetchState = function () {
        var newState: any = generateLocalStateFromEventProperties(currentAfr, ["workState_balanceSheetComplete", "workState_noBalanceSheet", "reviewState_balanceSheetReviewed"]);
        return newState;
    }
    const [state, setState] = React.useState<boolean>(fetchState());

    const updateState = function (newState: any) {
        setState(newState);
    }

    return (
        <React.Fragment>
            <BalanceSheetCore
                userRole={props.userRole}
                state={state}
                updateState={updateState}
            />
        </React.Fragment>
    );
}

export default BalanceSheetCoreWrapper;